"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var regexInvalidEntity = exports.regexInvalidEntity = /&#(?:[xX][^a-fA-F0-9]|[^0-9xX])/;


//////////////////
// WEBPACK FOOTER
// ./node_modules/lean-he/lib/regex/regex-invalid-entry.js
// module id = 1574
// module chunks = 0